import React from 'react';
import { BookOpenCheckIcon, CalendarDaysIcon, CheckIcon, ClipboardListIcon, DumbbellIcon } from 'lucide-react';
const stats = [[BookOpenCheckIcon, '350+', 'Pagine tecniche'], [ClipboardListIcon, '60+', 'Sessioni pronte all’uso'], [DumbbellIcon, '150+', 'Esercizi dettagliati'], [CalendarDaysIcon, '6', 'Volumi completi']];
const tags = ['Matwork Classico', 'Reformer', 'Piccoli attrezzi', 'Protocolli clinici', 'Gravidanza e terza età', 'Base · Intermedio · Avanzato'];
export function SystemSection() {
  return <section className="border-y-4 border-emerald-400 bg-[#38233c] px-5 py-20" data-id="element-215" data-mp="2wspcl993yzli">
      <div className="mx-auto max-w-6xl text-center" data-id="element-216" data-mp="2ssx3mvfsyrfm">
        <p className="inline-block bg-emerald-400 px-4 py-2 text-xs font-bold uppercase tracking-widest text-[#241322]" data-id="element-217" data-mp="2ntkiqg8hrufo">
          Il sistema più completo per le insegnanti di Pilates
        </p>
        <h2 className="mt-7 font-display text-5xl font-bold uppercase leading-none text-white sm:text-7xl" data-id="element-218" data-mp="2dvej65a5r0dz">
          PILATES <span className="text-emerald-300" data-id="element-219" data-mp="13yy6dijoy9in">PRONTA</span>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-base font-medium leading-relaxed text-slate-300" data-id="element-220" data-mp="18py24kh2qljk">
          Oltre 350 pagine di piani di lezione, esercizi professionali, disegni
          tecnici e guide cliniche per il tuo Pilates —{' '}
          <strong className="text-white" data-id="element-221" data-mp="z16fmrus8tg1">tutto già fatto per te.</strong>
        </p>
        <div className="mt-11 grid grid-cols-2 gap-3 lg:grid-cols-4" data-id="element-222" data-mp="1mpfwrgh1wt0u">
          {stats.map(([Icon, value, label]) => <div key={label} className="border border-emerald-300/25 bg-[#241622] p-6" data-id="element-223" data-mp="1rnhh04q7qydw">
              <Icon className="mx-auto h-7 w-7 text-emerald-300" data-id="element-224" data-mp="1ctmah5dj5l5v" />
              <p className="mt-4 font-display text-4xl font-bold text-white" data-id="element-225" data-mp="1hpbebkwl1o7z">
                {value}
              </p>
              <p className="text-xs font-bold uppercase tracking-widest text-slate-300" data-id="element-226" data-mp="1b1riv7zo7j9">
                {label}
              </p>
            </div>)}
        </div>
        <div className="mt-4 border border-emerald-300/25 bg-[#241622] p-7" data-id="element-227" data-mp="28x3a5nypmm81">
          <p className="text-xs font-bold uppercase tracking-[.2em] text-white" data-id="element-228" data-mp="23yi8dk3t7uhh">
            Copertura completa per ogni lezione e ogni allieva
          </p>
          <div className="mt-5 flex flex-wrap justify-center gap-2" data-id="element-229" data-mp="1z68j86aiqyg9">
            {tags.map(tag => <span key={tag} className="flex items-center gap-1.5 border border-emerald-300/25 bg-[#38233c] px-3 py-2 text-xs font-bold text-white" data-id="element-230" data-mp="1u7e2rb00xlzb">
                <CheckIcon className="h-3.5 w-3.5 text-emerald-300" data-id="element-231" data-mp="1lawq23c0hg1g" />
                {tag}
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}